// Synexis (redesign): assinatura manuscrita GERADA do nome — galeria "Trocar estilo"
// (handoff/03 telas 7 e 9). Renderiza o texto na fonte cursiva escolhida num canvas e
// injeta o PNG no input[type=file] do formulário (mesmo contrato dos modos desenhar/enviar).
//
// Markup esperado:
//   <typed-signature-form>
//     <input type="text" data-target="typed-signature-form.text">
//     <input type="radio" name="typed_style" value="Caveat" checked> (um por estilo)
//     <canvas data-target="typed-signature-form.canvas"></canvas>
//     <input type="file" data-target="typed-signature-form.input" class="hidden">
//   </typed-signature-form>
export default class extends HTMLElement {
  connectedCallback () {
    this.textInput = this.querySelector('[data-target="typed-signature-form.text"]')
    this.canvas = this.querySelector('[data-target="typed-signature-form.canvas"]')
    this.fileInput = this.querySelector('[data-target="typed-signature-form.input"]')

    this.onInput = () => this.redraw()

    this.addEventListener('input', this.onInput)
    this.addEventListener('change', this.onInput)

    this.redraw()
  }

  disconnectedCallback () {
    this.removeEventListener('input', this.onInput)
    this.removeEventListener('change', this.onInput)
  }

  get fontFamily () {
    return this.querySelector('input[name="typed_style"]:checked')?.value || 'Caveat'
  }

  async redraw () {
    const text = (this.textInput?.value || '').trim()

    const ctx = this.canvas.getContext('2d')

    this.canvas.width = 800
    this.canvas.height = 240

    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)

    if (!text) {
      this.clearFile()

      return
    }

    const font = `96px "${this.fontFamily}"`

    try {
      await document.fonts.load(font, text)
    } catch {}

    ctx.font = font
    // Tinta índigo da manuscrita (mockups: assinatura em índigo profundo).
    ctx.fillStyle = getComputedStyle(document.documentElement).getPropertyValue('--grad-a').trim() || '#2A06B0'
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'

    // Reduz a fonte até caber com folga lateral.
    let size = 96

    while (size > 24 && ctx.measureText(text).width > this.canvas.width - 60) {
      size -= 6
      ctx.font = `${size}px "${this.fontFamily}"`
    }

    ctx.fillText(text, this.canvas.width / 2, this.canvas.height / 2)

    this.canvas.toBlob((blob) => {
      if (!blob) return

      const transfer = new DataTransfer()

      transfer.items.add(new File([blob], 'signature.png', { type: 'image/png' }))

      this.fileInput.files = transfer.files
    }, 'image/png')
  }

  clearFile () {
    const transfer = new DataTransfer()

    this.fileInput.files = transfer.files
  }
}
